import { createRoute } from '@tanstack/react-router';
import { rotaPainel } from './painel';
import { Tela } from '../workspace/Tela';
import { DetalheDaRotina, FRASES_DA_ROTINA } from '../toolkit/DetalheDaRotina';
import { EditorDaRotina } from '../toolkit/EditorDaRotina';
import { usarRotina } from '../toolkit/consultas';
import { AvisoDeErro } from '../toolkit/pecas';
import { mensagemDoErro } from '../erros';

/**
 * As telas de UMA rotina do Toolkit (F3.7): o detalhe, a criação e a versão
 * nova. Endereços próprios, e não um painel por cima da lista: "Revisar" numa
 * proposta é um link que se manda a outra pessoa.
 *
 * `/toolkit/rotinas/nova` é segmento fixo, e o roteador o prefere ao `$id`.
 */

function Detalhe(): React.JSX.Element {
  const { id } = rotaRotinaDoToolkit.useParams();
  const { proposta } = rotaRotinaDoToolkit.useSearch();
  return (
    <Tela>
      <DetalheDaRotina id={id} {...(proposta ? { propostaEmFoco: proposta } : {})} />
    </Tela>
  );
}

export const rotaRotinaDoToolkit = createRoute({
  getParentRoute: () => rotaPainel,
  path: '/toolkit/rotinas/$id',
  validateSearch: (busca: Record<string, unknown>): { proposta?: string } =>
    typeof busca['proposta'] === 'string' && busca['proposta'] ? { proposta: busca['proposta'] } : {},
  component: Detalhe,
});

function Nova(): React.JSX.Element {
  return (
    <Tela>
      <EditorDaRotina base={null} />
    </Tela>
  );
}

export const rotaNovaRotina = createRoute({
  getParentRoute: () => rotaPainel,
  path: '/toolkit/rotinas/nova',
  component: Nova,
});

function NovaVersao(): React.JSX.Element {
  const { id } = rotaNovaVersaoDaRotina.useParams();
  const { data: rotina, error, isLoading } = usarRotina(id);
  return (
    <Tela>
      {isLoading ? <p className="text-sm text-zinc-500">carregando…</p> : null}
      {error ? <AvisoDeErro>{mensagemDoErro(error, 'Não foi possível carregar a rotina agora.', FRASES_DA_ROTINA)}</AvisoDeErro> : null}
      {/* A chave é a vigente: se ela mudar enquanto a pessoa escreve, o
          formulário recomeça dela em vez de gravar por cima de outra base. */}
      {rotina ? <EditorDaRotina key={rotina.vigente?.id ?? 'sem-vigente'} base={rotina} /> : null}
    </Tela>
  );
}

export const rotaNovaVersaoDaRotina = createRoute({
  getParentRoute: () => rotaPainel,
  path: '/toolkit/rotinas/$id/versao',
  component: NovaVersao,
});
